"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.fetch = exports.getFetchQuery = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const sok_types_1 = require("@caddigital/sok-types");
const actionTypes = require("../../actionTypes/management/projectUsers");
const actions = require("../../actions/management/projectUsers");
function getFetchQuery(params) {
    const res = [];
    if (params.customer) {
        res.push('customer=' + params.customer.id);
    }
    if (params.project) {
        res.push('project=' + params.project.id);
    }
    if (params.user) {
        res.push('userSearch=' + encodeURIComponent(params.user));
    }
    return res.join('&');
}
exports.getFetchQuery = getFetchQuery;
function fetch(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.FETCH_REQUEST), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/user/projects?${getFetchQuery(action.payload)}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .array(t.interface({
            user: sok_types_1.User.iUser,
            project: sok_types_1.Project.iProject,
            groups: t.array(sok_types_1.UserGroup.iUserGroup)
        }))
            .decode(response);
        const act = validation.fold((err) => actions.fetchFailed((0, errorHandling_1.parseValidationError)(err)), (res) => actions.fetchSuccess(res));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(err)))))));
}
exports.fetch = fetch;
function remove(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.REMOVE_REQUEST), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'DELETE',
        url: `${baseUrl}api/user-group/member`,
        body: action.payload
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(actions.removeSuccess())), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.removeFailed((0, errorHandling_1.parseAjaxErrorResponse)(err)))))));
}
exports.remove = remove;
//# sourceMappingURL=projectUsers.js.map